import type {
  DialogComponentProps,
  WORKSPACE_DIALOG_SCHEMA,
} from '@affine/core/modules/dialogs';
import { useCallback } from 'react';

import { SendEmailDialog as SendEmailComposeDialog } from './dialog';

/**
 * Registry entry for the "Send by email" dialog (YOD-426).
 *
 * The compose dialog is mounted from `<WorkspaceDialogs/>` at the workspace
 * layout root — deliberately a sibling of the Share menu rather than a
 * descendant of it. See the note on `'send-email'` in
 * `modules/dialogs/constant.ts`.
 */
export const SendEmailDialog = ({
  close,
  docId,
}: DialogComponentProps<WORKSPACE_DIALOG_SCHEMA['send-email']>) => {
  const handleClose = useCallback(() => close(), [close]);
  return <SendEmailComposeDialog docId={docId} open onClose={handleClose} />;
};
